import { render, staticRenderFns } from "./faq_section_mobile.vue?vue&type=template&id=1172bb55&scoped=true"
import script from "./faq_section_mobile.vue?vue&type=script&lang=js"
export * from "./faq_section_mobile.vue?vue&type=script&lang=js"
import style0 from "./faq_section_mobile.vue?vue&type=style&index=0&id=1172bb55&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1172bb55",
  null
  
)

export default component.exports